export default __webpack_public_path__ + "static/media/background_ellipse.80596e59.png";